import { render, staticRenderFns } from "./RichTextAreaToolbar.vue?vue&type=template&id=ce5f846a&scoped=true"
import script from "./RichTextAreaToolbar.vue?vue&type=script&lang=js"
export * from "./RichTextAreaToolbar.vue?vue&type=script&lang=js"
import style0 from "./RichTextAreaToolbar.vue?vue&type=style&index=0&id=ce5f846a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5f846a",
  null
  
)

export default component.exports